import React from 'react'
import { Microscope, ExternalLink } from 'lucide-react'
import LabService, { LAB_BASE_URL } from '../../../services/lab/LabService'
import { genId } from '../lib/id'
import type { LabCard } from '../types/LessonDoc'
import type { CardDef, CardEditorProps, CardPreviewProps } from './types'

// Thẻ Thí nghiệm Lab: chọn bài thí nghiệm IoT → click MỞ đúng trang lab.vatli365.vn
// (hoặc nhúng iframe). Danh sách lấy từ LabService (đồng bộ từ lab.vatli365.vn).
const Editor: React.FC<CardEditorProps> = ({ card, onChange }) => {
  const c = card as LabCard
  const all = LabService.getAll()
  return (
    <div className="space-y-3">
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">Chọn bài thí nghiệm Lab</label>
        <select
          className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200 bg-white"
          value={c.url || ''}
          onChange={(e) => {
            const exp = all.find((x) => `${LAB_BASE_URL}${x.url}` === e.target.value)
            onChange({ url: e.target.value || undefined, expTitle: exp?.title } as Partial<LabCard>)
          }}
        >
          <option value="">— Chọn thí nghiệm —</option>
          {all.map((x) => (
            <option key={x.id} value={`${LAB_BASE_URL}${x.url}`}>
              {x.title} (L{x.lop}·C{x.chuong}·B{x.bai})
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="text-xs font-bold text-gray-500 uppercase">hoặc dán link Lab</label>
        <input
          className="w-full p-2.5 border border-gray-200 rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-200"
          value={c.url || ''}
          onChange={(e) => onChange({ url: e.target.value || undefined } as Partial<LabCard>)}
          placeholder="https://lab.vatli365.vn/..."
        />
      </div>
      <label className="flex items-center gap-2 text-sm text-gray-600">
        <input type="checkbox" checked={!!c.embed} onChange={(e) => onChange({ embed: e.target.checked } as Partial<LabCard>)} />
        Nhúng trực tiếp (iframe) thay vì mở tab mới
      </label>
    </div>
  )
}

const Preview: React.FC<CardPreviewProps> = ({ card }) => {
  const c = card as LabCard
  if (!c.url) {
    return <div className="p-4 rounded-lg bg-gray-50 border border-dashed border-gray-200 text-gray-400 text-sm text-center">Chưa chọn bài thí nghiệm Lab.</div>
  }
  if (c.embed) {
    return (
      <iframe
        src={c.url}
        title={c.expTitle || 'Thí nghiệm Lab'}
        className="w-full rounded-lg border border-gray-200 bg-white"
        style={{ height: 560 }}
        allowFullScreen
      />
    )
  }
  return (
    <a
      href={c.url}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-3 p-4 rounded-xl border border-cyan-200 bg-cyan-50/60 hover:bg-cyan-50 transition-colors group"
    >
      <span className="w-11 h-11 rounded-xl bg-cyan-500 text-white flex items-center justify-center shrink-0">
        <Microscope size={22} />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[11px] font-black uppercase tracking-wide text-cyan-600">Thí nghiệm Lab IoT</span>
        <span className="block text-base font-bold text-gray-800 truncate">{c.expTitle || c.url}</span>
        <span className="block text-xs text-gray-400">Bấm để mở bài thí nghiệm tương ứng</span>
      </span>
      <ExternalLink size={18} className="text-cyan-500 shrink-0 group-hover:translate-x-0.5 transition-transform" />
    </a>
  )
}

export const labCardDef: CardDef = {
  type: 'lab',
  label: 'Thí nghiệm Lab',
  description: 'Mở/nhúng bài thí nghiệm IoT',
  icon: Microscope,
  color: 'bg-cyan-50 text-cyan-600',
  createDefault: (): LabCard => ({ id: genId(), type: 'lab' }),
  Editor,
  Preview,
}
